/* eslint-disable */
export default {
    profile_highest_advanced_education_level: "What is the highest level of advanced education you have received?",
    profile_highest_basic_education_level: "What is the highest level of primary or secondary education you have received?",
    profile_date_of_birth: "Date of birth",
    profile_gender: "Gender",
    profile_unexpected_error: "An error occurred while processing your request. Please try again.",
    profile_check_your_details_intro: "Please check your details and amend them if required",
    profile_check_your_details_title: "Your personal details",
    profile_check_your_details_save: "Save & proceed",
    profile_update_personal_data_error: "There was an error updating the personal information. Try again later.",
    profile_update_details_could_not_fetch_form_fields: "Could not fetch form field with id:",
    profile_feature_toggles_page_title: "Feature toggles",
    profile_update_details_success: "Profile successfully updated",
    profile_cv_section_modal_title: "Delete file",
    profile_cv_section_modal_body: "Are you sure you want to delete this file?",
    profile_cv_section_modal_cancel: "Cancel",
    profile_cv_section_modal_confirm: "Delete",
    profile_cv_section_title: "Upload resume",
    profile_cv_section_body: "We request you to upload your CV. The CV will be used as input for the interview with your LTP consultant, if this applies to you.",
    profile_education_title: "Education",
    profile_cv_section_delete_error: "Something went wrong when deleting the file. please try again later.",
    profile_cv_section_delete_success: "The file was deleted successfully.",
    profile_cv_section_upload_error: "Could not upload the file, please try again later.",
    profile_cv_section_download_error: "Could not download the file, please try again later.",
    profile_general_error: "Something went wrong. Please try again later.",
    profile_update_details_failed: "Something went wrong while updating the details.",
    profile_cv_section_upload_too_large: "The size of the uploaded file exceeds the maximum of 5Mb.",
    profile_date_of_birth_question: "What is your date of birth?",
    profile_amend_details_submit_button: "To program",
    profile_date_of_birth_invalid_format: "The format must be DD-MM-YYYY",
    profile_education_level_option_none: "None",
    profile_education_level_option_primary_education: "Primary education",
    profile_education_level_option_high_school: "High school",
    profile_education_level_option_vocational: "Vocational school",
    profile_education_level_option_college: "College",
    profile_education_level_option_university: "University",
    profile_education_level_option_phd: "PhD",
    profile_education_level_option_geen: "Geen",
    profile_education_level_option_havo: "Havo",
    profile_education_level_option_mavo_vmbo: "Mavo/vmbo",
    profile_education_level_option_praktijkonderwijs: "Praktijkonderwijs",
    profile_education_level_option_vwo: "Vwo",
    profile_education_level_option_hbo: "HBO",
    profile_education_level_option_mbo1: "MBO 1",
    profile_education_level_option_mbo2: "MBO 2",
    profile_education_level_option_mbo3: "MBO 3",
    profile_education_level_option_mbo4: "MBO 4",
    profile_education_level_option_bachelor: "WO bachelor",
    profile_education_level_option_master: "WO master",
    profile_select_active_competencies_label: "Which competencies would you like to measure? (min. 1)",
    profile_education_level_option_other: "Other",
    profile_language_fluency_level: "Please indicate your level of fluency in",
    profile_language_fluency_level_primary: "Primary / bilingual fluency",
    profile_language_fluency_level_full_professional: "Fluent",
    profile_language_fluency_level_professional_working: "Good proficiency",
    profile_language_fluency_level_limited_working: "Limited proficiency",
    profile_language_fluency_level_elementary: "Elementary proficiency",
    profile_Language_fluency_level_limited_proficiency: "Limited proficiency",
    profile_Language_fluency_level_proficient: "Proficient",
    profile_Language_fluency_level_fluent: "Fluent",
    profile_Language_fluency_level_secondary: "Bilingual or multilingual with English as a second language",
    profile_Language_fluency_level_native: "Native / English as primary language",
    profile_amend_details_submit_without_cv_button: "Continue without CV"
};
